// all translate-dev urls must be dynamic depend on the environment from config.environment_name
// for dev is translate-dev
// for preprod is translate-preprod
// and for prod is translate

import config from '../../../config';

const URL_DATA: Record<string, { [key: string]: string }> = {
  dev: {
    vendorTranslation:
      'https://translate-dev.sd.astrazeneca.com/web/translate/vendor-upload',
    myQuotes:
      'https://translate-ngs-dev.sd.astrazeneca.com/web/translate/vendor-orders',
    ngsServiceRequests:
      'https://translate-ngs-dev.sd.astrazeneca.com/web/ngs/service-request',
    translationManager:
      'https://translate-ngs-dev.sd.astrazeneca.com/web/translate/view-documents',
    admin:
      'https://translate-ngs-dev.sd.astrazeneca.com.sd.astrazeneca.com/web/admin',
  },
  preprod: {
    vendorTranslation:
      'https://translate-preprod.sd.astrazeneca.com/web/translate/vendor-upload',
    myQuotes:
      'https://translate-ngs-preprod.sd.astrazeneca.com/web/translate/vendor-orders',
    ngsServiceRequests:
      'https://translate-ngs-preprod.sd.astrazeneca.com/web/ngs/service-request',
    translationManager:
      'https://translate-ngs-preprod.sd.astrazeneca.com/web/translate/view-documents',
    admin: 'https://translate-ngs-preprod.sd.astrazeneca.com.web/admin',
  },
  prod: {
    vendorTranslation:
      'https://translate-ngs.astrazeneca.com/web/translate/vendor-upload',
    myQuotes:
      'https://translate-ngs.astrazeneca.com/web/translate/vendor-orders',
    ngsServiceRequests:
      'https://translate-ngs.astrazeneca.com/web/ngs/service-request',
    translationManager:
      'https://translate-ngs.astrazeneca.com/web/translate/view-documents',
    admin: 'https://translate-ngs.astrazeneca.com/web/admin',
  },
};

export const EXTERNAL_URLS = {
  profileImageBaseUrl: 'https://adhoc.rd.astrazeneca.net/api/thumbs',
  vendorTranslation: URL_DATA[config.environment_name]['vendorTranslation'],
  myQuotes: URL_DATA[config.environment_name]['myQuotes'],
  ngsServiceRequests: URL_DATA[config.environment_name]['ngsServiceRequests'],
  translationManager: URL_DATA[config.environment_name]['translationManager'],
  admin: URL_DATA[config.environment_name]['admin'],
  azureLoginBanner:
    'https://aadcdn.msftauthimages.net/c1c6b6c8-ssimvxpb9qdv8nffqqltxmis1nxfqs5utx0cwh6q-vm/logintenantbranding/0/bannerlogo?ts=638043642020989581',
} as const;
